<section>
  <h1>About Me</h1>
  <div class="section">
    <div class="description">
      <p>
        Hey there! I'm a second-year student at Rutgers University-New Brunswick
        from Princeton, New Jersey (Central Jersey exists!), double majoring in
        Computer Science and Finance.
      </p>
      <p>
        My introduction to computer science was in my 8th-grade computer
        programming class. I still vividly remember how I sat in front of my
        computer for hours trying to get the little turtle in Terrapin Logo to
        write "Hello World". It did not take me long to learn to love the
        frustration and fulfillment that came with programming. I became
        obsessed with coding for anything and anyone. My passion lies in finding
        a way to use programming to solve any and every problem.
      </p>
      <p>
        Finance is a major that I chose after a lot of consideration. Initially,
        I wanted a business-related major to advance my career into more than
        software engineering. However, my time exploring at Rutgers Business
        School(RBS) has taught me that Finance is more than numbers. Finance
        will give me the ability to have better insight into what the companies
        and individuals need. With this unique skill set, I know that I can
        solve any and every problem.
      </p>
      <p>
        Outside of Computer Science and Finance, you can find me working with a
        fantastic group of people to empower women in STEM and leadership roles
        through Rutgers WiCS (Women in Computer Science) and RBS's Women BUILD
        (Business Undergraduates Leadership Development (phew, that's a
        mouthful)), mentoring freshman, helping my classmates learn Calculus II
        as a teaching assistant, drawing my favorite musicians, actors, and
        actresses, getting bubble tea, or learning Korean.
      </p>
      <p>
        Talk to me about your creative side hustles, favorite tunes, movies, tv
        shows, activism, or foods!
      </p>
    </div>

    <div class="picture">
      <img src="assets/Images/AboutMe.jpg" alt="" />
    </div>
  </div>
</section>
